
[
  {
    "id": "TG-M8-001",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een auto rijdt 450 km in 5 uur. Wat is de gemiddelde snelheid?",
    "options": ["90 km/u", "80 km/u", "100 km/u", "85 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-GEM",
    "explanation": "Snelheid = afstand : tijd. 450 : 5 = 90 km/u.",
    "distractorExplanations": { "1": "450 : 5 = 90, niet 80.", "2": "450 : 5 = 90, niet 100.", "3": "450 : 5 = 90, niet 85." }
  },
  {
    "id": "TG-M8-002",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "In een lijndiagram zie je dat de verkoop in januari 200 was, in maart 350 en in mei 500. Wat is de trend?",
    "options": ["De verkoop stijgt steeds meer", "De verkoop daalt", "De verkoop blijft gelijk", "De verkoop schommelt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-LIJN-TREND",
    "explanation": "Van 200 naar 350 is +150. Van 350 naar 500 is ook +150. De lijn stijgt steeds met hetzelfde bedrag.",
    "distractorExplanations": { "1": "De getallen worden steeds groter, dus de verkoop stijgt.", "2": "De getallen veranderen wel, ze worden groter.", "3": "De lijn gaat steeds omhoog, er is geen schommeling." }
  },
  {
    "id": "TG-M8-003",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een hardloper rent 12 km in 48 minuten. Hoeveel minuten doet hij over 1 km?",
    "options": ["4 minuten", "3 minuten", "5 minuten", "6 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-HARDLOPER",
    "explanation": "48 minuten : 12 km = 4 minuten per km.",
    "distractorExplanations": { "1": "12 × 3 = 36, dat is te weinig minuten.", "2": "12 × 5 = 60, dat is te veel minuten.", "3": "12 × 6 = 72, dat is veel te veel." }
  },
  {
    "id": "TG-M8-004",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een dubbel staafdiagram toont het energieverbruik:\n\n2020: Gas 1200 m³, Elektra 3000 kWh\n2023: Gas 800 m³, Elektra 3500 kWh\n\nWelke conclusie klopt?",
    "options": ["Het gasverbruik is gedaald, het elektraverbruik is gestegen", "Beide zijn gedaald", "Beide zijn gestegen", "Het gasverbruik is gestegen, het elektraverbruik is gedaald"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-DUBBEL-STAAF",
    "explanation": "Gas: 1200 → 800 (gedaald). Elektra: 3000 → 3500 (gestegen).",
    "distractorExplanations": { "1": "Elektra is gestegen (3000 → 3500), niet gedaald.", "2": "Gas is gedaald (1200 → 800), niet gestegen.", "3": "Het is precies andersom." }
  },
  {
    "id": "TG-M8-005",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Twee fietsers vertrekken tegelijk. Fietser A rijdt 18 km/u, fietser B rijdt 12 km/u. Na 2 uur: hoeveel km voorsprong heeft fietser A?",
    "options": ["12 km", "6 km", "18 km", "24 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-VERSCHIL",
    "explanation": "Verschil in snelheid: 18 - 12 = 6 km/u. Na 2 uur: 6 × 2 = 12 km voorsprong.",
    "distractorExplanations": { "1": "6 km is het verschil na 1 uur, niet na 2 uur.", "2": "18 km is de afstand die fietser A in 1 uur aflegt.", "3": "24 km is de afstand die fietser B in 2 uur aflegt." }
  },
  {
    "id": "TG-M8-006",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "In een tabel staat het aantal bezoekers per maand:\nJan: 1.200, Feb: 1.400, Mrt: 1.800, Apr: 2.400\n\nWat valt op aan de groei?",
    "options": ["De groei wordt steeds groter (versnelling)", "De groei is steeds gelijk", "De groei wordt steeds kleiner", "Er is geen groei"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TG-TABEL-GROEI",
    "explanation": "Jan→Feb: +200. Feb→Mrt: +400. Mrt→Apr: +600. De toename wordt steeds groter.",
    "distractorExplanations": { "1": "De toenames zijn 200, 400, 600 — die zijn niet gelijk.", "2": "De toenames worden juist groter, niet kleiner.", "3": "Er is wel groei: de getallen worden steeds groter." }
  },
  {
    "id": "TG-M8-007",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een trein vertrekt om 14:23 en komt aan om 16:08. Hoe lang duurt de reis?",
    "options": ["1 uur en 45 minuten", "1 uur en 35 minuten", "2 uur en 15 minuten", "1 uur en 55 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-TIJDSDUUR-TREIN",
    "explanation": "Van 14:23 naar 16:08. Van 14:23 naar 16:23 = 2 uur. Maar 16:08 is 15 minuten eerder dan 16:23. Dus 2 uur - 15 min = 1 uur 45 min.",
    "distractorExplanations": { "1": "Rekenfout bij de minuten.", "2": "Je telde te veel uren.", "3": "Rekenfout bij de minuten." }
  },
  {
    "id": "TG-M8-008",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "In een cirkeldiagram is het huishoudbudget verdeeld:\nHuur: 35%, Eten: 25%, Vervoer: 15%, Sparen: 10%, Overig: 15%\n\nHet maandinkomen is € 2.000. Hoeveel gaat er naar huur?",
    "options": ["€ 700", "€ 500", "€ 350", "€ 600"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-CIRKEL-BUDGET",
    "explanation": "35% van € 2.000 = 0,35 × 2.000 = € 700.",
    "distractorExplanations": { "1": "25% van 2.000 = 500. Dat is het bedrag voor eten.", "2": "350 is de helft van 700. Je rekende met 17,5%.", "3": "30% van 2.000 = 600. Maar het is 35%." }
  },
  {
    "id": "TG-M8-009",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een zwemmer zwemt 50 meter in 30 seconden. Wat is zijn snelheid in km per uur?",
    "options": ["6 km/u", "3 km/u", "50 km/u", "1,5 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-ZWEMMER",
    "explanation": "50 m in 30 sec = 100 m per minuut = 6.000 m per uur = 6 km/u.",
    "distractorExplanations": { "1": "Je deelde door 2 in plaats van te vermenigvuldigen.", "2": "50 m/s zou 180 km/u zijn. Dat is veel te snel.", "3": "Je maakte een fout bij het omrekenen." }
  },
  {
    "id": "TG-M8-010",
    "module": "TijdGeld",
    "difficulty": 303,
    "question": "Een grafiek toont de temperatuur gedurende de dag:\n8:00 = 8°C, 12:00 = 16°C, 16:00 = 14°C, 20:00 = 10°C\n\nOm hoe laat was het het warmst?",
    "options": ["Om 12:00 uur", "Om 16:00 uur", "Om 8:00 uur", "Om 20:00 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-GRAFIEK-WARMST",
    "explanation": "De hoogste temperatuur is 16°C om 12:00 uur. Daarna daalt de temperatuur weer.",
    "distractorExplanations": { "1": "Om 16:00 was het 14°C, dat is minder dan 16°C.", "2": "Om 8:00 was het 8°C, het koudste moment.", "3": "Om 20:00 was het 10°C." }
  }
]
